import { getStaticFilesURL } from './getStaticFilesURL';
import type { Env } from './types';

export const getCuratorSvgUrl = (env: Env, port?: string) =>
  getStaticFilesURL(env, 'img/curator-stars.svg', port);
